"use client";

import BoxWithTitle from "../../../common/BoxWithTitle";
import Comment from "./comments-helpers/Comment";
import SvgComments from "./comments-helpers/svgs/SvgComments";
import CommentForm from "./comments-helpers/CommentForm";
import { useGetAllBlogCommentsInfiniteQuery } from "@/api/AppApi/services/blogs";
import { useState } from "react";
import { useIsMobile } from "@/hooks/useIsMobile";
import GeneralApiLoader from "@/app/components/lib/loaders/GeneralApiLoader";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface porps {
  blogId: number;
  blogSlug: string;
}
const Comments: React.FC<porps> = ({ blogSlug }) => {
  const t = useTranslation();
  const isMobile = useIsMobile();
  const [selectedCommentToReply, setSelectedCommentToReply] = useState<
    number | null
  >(null);
  const getAllBlogCommentsInfinte = useGetAllBlogCommentsInfiniteQuery({
    blogSlug,
    params: {},
    enabled: true,
  });
  const allCommentsPages = getAllBlogCommentsInfinte?.data?.pages;
  const { total, per_page } = allCommentsPages?.[0]?.result?.meta ?? {};
  const [restComments, setRestComments] = useState(
    total! - per_page! > 0 ? total! - per_page! : 0,
  );
  const mClass = isMobile ? "-mobile" : "";
  if (!allCommentsPages) return <GeneralApiLoader />;
  return (
    <BoxWithTitle
      title={
        <>
          <SvgComments /> {total} {t.comments}
        </>
      }
    >
      <div className="blog-comments">
        {allCommentsPages?.map((page) =>
          page?.result?.data?.map((comment) => (
            <Comment
              key={"comment" + blogSlug + comment?.id}
              blogSlug={blogSlug}
              isReply={false}
              showCommentForm={selectedCommentToReply === comment?.id}
              id={comment?.id}
              user={comment?.user}
              date={comment?.date}
              content={comment?.content}
              likes={comment?.likes}
              dislikes={comment?.dislikes}
              replies={comment?.replies!}
              reaction={comment?.reaction}
              selectedCommentToReply={selectedCommentToReply}
              setSelectedCommentToReply={setSelectedCommentToReply}
              isMobile={isMobile}
              replies_count={comment?.replies_count}
            />
          )),
        )}

        {getAllBlogCommentsInfinte &&
          getAllBlogCommentsInfinte?.hasNextPage && (
            <div
              className={`show-more-replies${mClass}`}
              onClick={() => {
                getAllBlogCommentsInfinte?.fetchNextPage();
                setRestComments((restComments) =>
                  restComments - per_page! > 0 ? restComments - per_page! : 0,
                );
              }}
            >
              {t.show_more_comments + ` (${restComments})`}
            </div>
          )}
        {getAllBlogCommentsInfinte?.isFetching && (
          <div className="w-100 d-flex justify-content-center">
            <Spinner className="comment-spinner" />
          </div>
        )}
        {!selectedCommentToReply && (
          <>
            {" "}
            <hr />
            <CommentForm
              commentID={null}
              blogSlug={blogSlug}
              callBack={() => {
                getAllBlogCommentsInfinte?.refetch();
              }}
            />
          </>
        )}
      </div>
    </BoxWithTitle>
  );
};

export default Comments;
